import { setFromArray } from './setFromArray';
/**
 * @since 0.5.7
 */
export function readonlySetFromArray(codec, O, name) {
    if (name === void 0) { name = "ReadonlySet<" + codec.name + ">"; }
    return setFromArray(codec, O, name);
}
